import ExpandableContainer from '../../ExpandableContainer'
import GroupByAvailableColumnsTable from './GroupByAvailableColumnsTable'
import AssignActions from '../table/AssignActions'
import GroupByColumnsTable from './GroupByColumnsTable'
import GroupByColumnsContextProvider from './GroupByColumnsContext'

const GroupByColumns = () => {
    return (
        <GroupByColumnsContextProvider>
            <ExpandableContainer
                title="Group By Columns"
                leftContent={<GroupByAvailableColumnsTable />}
                centerContent={<AssignActions mode="groupBy" />}
                rightContent={<GroupByColumnsTable />}
            >
            </ExpandableContainer>
        </GroupByColumnsContextProvider>
    )
}

export default GroupByColumns